import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";

export class ReportingPeriod {
    public StartDate: Date | null = null;
    public EndDate: Date | null = null;

    public constructor(init?: NonFunctionProperties<ReportingPeriod>) {
        this.StartDate = init?.StartDate;
        this.EndDate = init?.EndDate;
    }
}
